import React from 'react';
import s from './Menu.scss';
import { Arrow } from '../Arrow/Arrow';
import { useSettings } from '../../providers/SettingsProvider';
import { useView, View } from '../../providers/ViewProvider';
import { useGetPlaybackRateText } from '../Speed/Speed';
import { useTexts } from '../../useTexts';
const MenuItem = _ref => {
  let {
    title,
    value,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    className: s.button,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: s.title
  }, title), /*#__PURE__*/React.createElement("span", null, value), /*#__PURE__*/React.createElement(Arrow, null)));
};
export const Menu = () => {
  const {
    playbackRate
  } = useSettings();
  const {
    setView
  } = useView();
  const getPlaybackRateText = useGetPlaybackRateText();
  const {
    menuSpeedTitle
  } = useTexts();
  return /*#__PURE__*/React.createElement("ul", {
    className: s.list
  }, /*#__PURE__*/React.createElement(MenuItem, {
    title: menuSpeedTitle,
    value: getPlaybackRateText(playbackRate),
    onClick: () => setView(View.Speed)
  }));
};
//# sourceMappingURL=Menu.js.map